import { number, string, bool, } from 'prop-types';
import styled from 'styled-components';

const Divider = styled.div`
  flex: 1 1 auto;
  padding: 0 16px;
  display: none;

  span {
    display: block;
    border: 1px solid ${({ theme }) => theme.colors.bg_gray};
  }

  @media screen and (min-width: 768px) {
    display: block;
  }
`;

const Bullet = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({theme}) => theme.colors.bg_gray_dark};
  color: ${({theme}) => theme.colors.white};
  border-radius: 50px;
  width: 32px;
  height: 32px;
  font-weight: bold;
  margin-right: 16px;
`;

const Label = styled.span`
  color: ${({theme}) => theme.colors.bg_gray_dark};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 16px;
  }

  ${({theme, isActive}) => isActive &&
  `
    ${Bullet} {
      background-color: ${theme.colors.brand_blue};
    }

    ${Label} {
      color: ${theme.colors.text_dark};
      font-weight: bold;
    }
  `};

  @media screen and (min-width: 768px) {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

function StepperItem({
  className,
  stepNumber,
  isActive,
  isLastStep,
  label,
}) {
  return (
    <>
      <Wrapper className={className} isActive={isActive}>
        <Bullet>
          {stepNumber}
        </Bullet>
        <Label>{label}</Label>
      </Wrapper>
      {
        !isLastStep && (
          <Divider>
            <span />
          </Divider>
        )
      }
    </>
  );
}

StepperItem.propTypes = {
  className: string,
  stepNumber: number.isRequired,
  isActive: bool.isRequired,
  isLastStep: bool.isRequired,
  label: string.isRequired,
};

StepperItem.defaultProps = {
  className: '',
}

export default styled(StepperItem)``;